import { Request } from "./request"

export interface Prison {
  status?: number
  id?: string
  cautionTotal?: number
  handleTotal?: number
  medicalTotal?: number
  organizationTotal?: number
  validAcOrgTc?: number
  osName?: string
}

export interface PrisonParams {
  id?: any
  scope?: number
}

export function getPrisionPage(params: PrisonParams): Request {
  return {
    url: `/api/analysis/org/supervise/index`,
    method: "GET",
    params,
  }
}

export interface excelParams {
  scope?: number
  regionCode?: string
}

export function exportExcel(params: excelParams): Request {
  return {
    url: `api/analysis/area/index/export`,
    method: "GET",
    responseType: "blob",
    params: {
      scope: params.scope,
    },
  }
}
